import React from "react";
import {Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, Progress, Text} from "@chakra-ui/react";

interface ProgressOverlayProps {
    isOpen: boolean;
    title: string;
    done: number;
    total: number;
    message?: string;
}

/** Reusable non-dismissible progress modal for bulk API operations (Copy/Edit/Clear). */
export function ProgressOverlay({isOpen, title, done, total, message}: ProgressOverlayProps) {
    const safeTotal = Math.max(total || 1, 1);
    const value = Math.min(Math.max(done, 0), safeTotal);
    return (
        <Modal isOpen={isOpen} onClose={() => undefined} isCentered closeOnOverlayClick={false} closeOnEsc={false}>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>{title}</ModalHeader>
                <ModalBody pb={6}>
                    <Progress value={(value / safeTotal) * 100} size="lg" colorScheme="blue" borderRadius="md" mb={3}/>
                    <Text fontSize="sm" color="gray.600">
                        {value}/{safeTotal} completed{message ? ` — ${message}` : ""}
                    </Text>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}
